import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import "./addDevicePopup.css";
import ButtonComponent from "../ButtonComponent/ButtonComponent";

const AddDevicePopup = ({
  show,
  setShow,
  data,
  addDeviceSubmit,
  setSelectedIds,
  handleClose = () => setShow(false),
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredDevices = (data || []).filter((device) =>
    device.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleCheckboxChange = (_id) => {
    setSelectedIds((prevSelectedIds) => 
      prevSelectedIds.includes(_id)
        ? prevSelectedIds.filter((selectedId) => selectedId !== _id)
        : [...prevSelectedIds, _id]
  );
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="addDevice-modal"
    >
      <Modal.Header>
        <Modal.Title>Add Device</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Search Bar */}
        <Form.Group className="mb-3" controlId="searchBar">
          <Form.Control
            type="text"
            placeholder="Search Devices..."
            className="mb-3 addDevice-SearchBar"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Form.Group>
        <div className="modal-content-scroll">
          {/* {data.map((section, index) => (
            <div key={index} className="mb-4">
              <h6 className="section-heading">{section.heading}</h6>
              {section.options.map((option, idx) => (
                <Form.Check
                  type="checkbox"
                  key={idx}
                  id={`${section.heading}-${idx}`}
                  label={option}
                  className="mb-2"
                />
              ))}
            </div>
          ))} */}
          {filteredDevices.length > 0 ? (
            filteredDevices.map((device) => (
              <div key={device._id} className="mb-4">
                <Form.Check
                  type="checkbox"
                  id={`device-${device._id}`}
                  label={device.name}
                  className="mb-2"
                  onChange={() => handleCheckboxChange(device._id)}
                />
              </div>
            ))
          ) : (
            <p>No devices found.</p>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <ButtonComponent
          type="transparent"
          buttonText={"Cancel"}
          className={"addDeviceCancelbtn"}
          onClick={()=>{handleClose(); setSearchTerm("")}}
        />
        <ButtonComponent
          buttonText={"Add Device"}
          className={"addDevicebtn"}
          onClick={() => {addDeviceSubmit(); setSearchTerm("")}}
        />
      </Modal.Footer>
    </Modal>
  );
};

export default AddDevicePopup;
